import React, { useState, useEffect, useMemo } from "react";
import { throttle } from "lodash";
import "./GotoTop.scss";

export default function GotoTop() {
  const [ScrollY, setScrollY] = useState(0);
  const [showScroll, setShowScroll] = useState(false);

  function goTop() {
    //document.documentElement.scrollTop = 0;

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    setScrollY(0);
    setShowScroll(false);
  }

  useEffect(() => {
    if (ScrollY > 100) {
      if (showScroll === false) setShowScroll(true);
    } else {
      if (showScroll === true) setShowScroll(false);
    }

    // console.log("ScrollY is ", ScrollY, "showScroll : ", showScroll);
  }, [ScrollY]);

  const throttledScroll = useMemo(
    () =>
      throttle(() => {
        let y = window.scrollY || window.pageYOffset;
        setScrollY(y);
      }, 1000),
    []
  );

  useEffect(() => {
    window.addEventListener("scroll", throttledScroll);

    return () => {
      window.removeEventListener("scroll", throttledScroll);
    };
  }, [throttledScroll]);

  return (
    <div
      className={
        "component-gotop" +
        (showScroll === true ? " component-gotop-active" : "")
      }
      onClick={goTop}
      // showScrollCheck={showScroll}
    >
      <img
        className="component-gotop-image"
        src={process.env.PUBLIC_URL + "/images/ico_top_btn.png"}
        alt=""
      ></img>
    </div>
  );
}
